import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'content'];

  connect() {
    this.input = this.element.querySelector('input[type="checkbox"]');
    this.toggleContent();
    this.input.addEventListener('change', () => this.toggleContent());
  }

  toggleContent() {
    if (this.input.checked) {
      this.contentTarget.classList.remove('hidden');
      this.contentTarget.classList.add('flex');
    } else {
      this.contentTarget.classList.add('hidden');
      this.contentTarget.classList.remove('flex');
    }
  }
}
